if (!customElements.get('indigo-feature-videos')) {
  customElements.define('indigo-feature-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.playbackCleanup) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cleanups = [];
      this.querySelectorAll('video').forEach((video) => {
        let inView = false;
        let manuallyPaused = false;
        let automaticPause = false;
        const pauseAutomatically = () => {
          if (video.paused) return;
          automaticPause = true;
          video.pause();
        };
        const updatePlayback = () => {
          video.loop = !reducedMotion.matches;
          if (!inView || document.hidden || reducedMotion.matches) {
            pauseAutomatically();
            return;
          }
          if (!manuallyPaused) video.play().catch(() => {});
        };
        const onPause = () => {
          if (automaticPause) automaticPause = false;
          else manuallyPaused = true;
        };
        const onPlay = () => { manuallyPaused = false; };
        video.autoplay = false;
        video.loop = !reducedMotion.matches;
        video.addEventListener('pause', onPause);
        video.addEventListener('play', onPlay);
        const observer = 'IntersectionObserver' in window ? new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting && entry.intersectionRatio >= 0.3;
          updatePlayback();
        }, { threshold: [0, 0.3] }) : null;
        observer?.observe(video);
        reducedMotion.addEventListener('change', updatePlayback);
        document.addEventListener('visibilitychange', updatePlayback);
        cleanups.push(() => {
          observer?.disconnect();
          video.pause();
          video.removeEventListener('pause', onPause);
          video.removeEventListener('play', onPlay);
          reducedMotion.removeEventListener('change', updatePlayback);
          document.removeEventListener('visibilitychange', updatePlayback);
        });
      });
      this.playbackCleanup = () => cleanups.forEach((cleanup) => cleanup());
    }
    disconnectedCallback() {
      this.playbackCleanup?.();
      this.playbackCleanup = null;
    }
  });
}
